import { ProductCategory } from "./productCategory/productCategory";
import { Product } from "./productCategory/product/product";
import { Paper } from "./productCategory/product/paper/paper";
import { TemplateCategory } from "./templateCategory/templateCategory";
import { TemplateColor } from "./templateColor/templateColor";
import { Template } from "./template/template";
import { ImageCategory } from "./imageCategory/imageCategory";
import { Image } from "./image/image";

import { Const } from "@/const";

//型
import { productSearchInfo } from "@/definitions/productSearchInfo";
import { templateSearchInfo } from "@/definitions/templateSearchInfo";

//ヘルパー
import { CreateGetParamHelper } from "@/helper/createGetParamHelper";
import { CreatePostParamHelper } from "@/helper/createPostParamHelper";
import { RequestHelper } from "@/helper/requestHelper";
import { RegionHelper } from "@/helper/regionHelper";
import { DebugHelper } from "@/helper/debugHelper";

import { getRecentImages, getRecentTemplates } from "@/data/items-recent";

//リンク
import * as Enumerable from "linq-es5";

import { LogHelper } from "@/helper/logHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { ShapeInfo } from "./productCategory/product/paper/frameInfo/shapeInfo/shapeInfo";
import { FrameInfo } from "./productCategory/product/paper/frameInfo/frameInfo";
import {
    XHRProductRepository,
    IDBProductRepository,
    IProductRepository
} from "./product-repository";
import platform from "@/helper/platform";
import ipcApi from '@/api/ipc-api'

const TEMPLATE_CATEGORY_RECENT_ITEM_NAME = '最近使った項目'

export class Data {
    //↓↓↓↓↓↓↓↓↓↓無限スクロールのローディング↓↓↓↓↓↓↓↓↓↓
    private _isLoadNewVisibleProduct: boolean = true;
    set isLoadNewVisibleProduct(visibility: boolean) {
        this._isLoadNewVisibleProduct = visibility;
    }
    get isLoadNewVisibleProduct(): boolean {
        return this._isLoadNewVisibleProduct;
    }
    private _isLoadNewVisibleTemplate: boolean = true;
    set isLoadNewVisibleTemplate(visibility: boolean) {
        this._isLoadNewVisibleTemplate = visibility;
    }
    get isLoadNewVisibleTemplate(): boolean {
        return this._isLoadNewVisibleTemplate;
    }
    //↑↑↑↑↑↑↑↑↑↑無限スクロールのローディング↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓ページ全体のローディング↓↓↓↓↓↓↓↓↓↓
    private _isLoadAllVisibleProduct: boolean = true;
    set isLoadAllVisibleProduct(visibility: boolean) {
        this._isLoadAllVisibleProduct = visibility;
    }
    get isLoadAllVisibleProduct(): boolean {
        return this._isLoadAllVisibleProduct;
    }
    private _isLoadAllVisibleTemplate: boolean = true;
    set isLoadAllVisibleTemplate(visibility: boolean) {
        this._isLoadAllVisibleTemplate = visibility;
    }
    get isLoadAllVisibleTemplate(): boolean {
        return this._isLoadAllVisibleTemplate;
    }
    //↑↑↑↑↑↑↑↑↑↑ページ全体のローディング↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓プロダクト、ペイパー↓↓↓↓↓↓↓↓↓↓
    private _productTotalCount: number = 0;
    set productTotalCount(totalCount: number) {
        this._productTotalCount = totalCount;
    }
    get productTotalCount(): number {
        return this._productTotalCount;
    }

    private _productCategoryList: ProductCategory[] = [new ProductCategory()];
    set productCategoryList(productCategoryList: ProductCategory[]) {
        this._productCategoryList = productCategoryList;
    }
    get productCategoryList(): ProductCategory[] {
        return this._productCategoryList;
    }
    private _selectedProduct: Product = new Product();
    set selectedProduct(product: Product) {
        this._selectedProduct = product;
    }
    get selectedProduct(): Product {
        return this._selectedProduct;
    }
    private _selectedPaper: Paper = new Paper();
    set selectedPaper(paper: Paper) {
        this._selectedPaper = paper;
    }
    get selectedPaper(): Paper {
        return this._selectedPaper;
    }
    //用紙の向き(0:回転しない,1:90度回転,2:180度回転,3:270度回転)
    private _paperDirection: number = 0;
    set paperDirection(direction: number) {
        this._paperDirection = direction;
    }
    get paperDirection(): number {
        return this._paperDirection;
    }

    productSearchInfo: productSearchInfo = {
        width: 0,
        height: 0,
        range: 3,
        searchWord: "",
        scrollNew: false,
        productCategorySortNum: 0,
        productCount: 0,
        platform: platform.id,
        region: RegionHelper.getRegion()
    };

    //トップコントローラーを切り替える為だけのパラーメーター
    productSearchType: string = "text";
    //検索方法を確定した時
    productSearchTypeConfirmed: string = "nothing";
    //↑↑↑↑↑↑↑↑↑↑プロダクト、ペイパー↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓テンプレートカテゴリー↓↓↓↓↓↓↓↓↓↓
    private _templateCategoryList: TemplateCategory[] = [
        new TemplateCategory(TEMPLATE_CATEGORY_RECENT_ITEM_NAME)
    ];
    set templateCategoryList(templateCategoryList: TemplateCategory[]) {
        this._templateCategoryList = templateCategoryList;
    }
    get templateCategoryList() {
        return this._templateCategoryList;
    }
    private _selectedTemplateCategory: TemplateCategory = new TemplateCategory(TEMPLATE_CATEGORY_RECENT_ITEM_NAME);
    set selectedTemplateCategory(templateCategory: TemplateCategory) {
        this._selectedTemplateCategory = templateCategory;
    }
    get selectedTemplateCategory(): TemplateCategory {
        return this._selectedTemplateCategory;
    }

    //検索候補配列
    searchSelection: any = [];

    //いっぺんに近いもの表示
    displayResembles = true;
    //↑↑↑↑↑↑↑↑↑↑テンプレートカテゴリー↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓テンプレートリスト↓↓↓↓↓↓↓↓↓↓
    private _templateTotalCount: number = 0;
    set templateTotalCount(totalCount: number) {
        this._templateTotalCount = totalCount;
    }
    get templateTotalCount(): number {
        return this._templateTotalCount;
    }

    // get_template_list.phpで投げる page
    private getTemplatePage: number = 0;

    private _templateList: Template[] = [];
    set templateList(templateList: Template[]) {
        this._templateList = templateList;
    }
    get templateList() {
        return this._templateList;
    }
    // テンプレートリストを追加する
    // return : 追加したテンプレートの数
    private concatTemplateList(templates: Template[]) {
        var addTemplates: Template[] = [];
        for (var i = 0; i < templates.length; ++i) {
            var addTemplate = templates[i];
            var isExistId = false;
            for (var j = 0; j < this.templateList.length; ++j) {
                if (addTemplate.id == this.templateList[j].id) {
                    // Idが存在する
                    isExistId = true;
                    break;
                }
            }

            // Idが存在しなかったら追加
            if (!isExistId) {
                addTemplates.push(addTemplate);
            }
        }

        // 追加
        this.templateList = this.templateList.concat(addTemplates);
        return addTemplates.length;
    }

    private _selectedTemplate: Template = new Template();
    set selectedTemplate(template: Template) {
        this._selectedTemplate = template;
    }
    get selectedTemplate(): Template {
        return this._selectedTemplate;
    }

    //縦横比固定か
    private _isTemplateFixed: boolean = false;
    set isTemplateFixed(fixed: boolean) {
        this._isTemplateFixed = fixed;
    }
    get isTemplateFixed(): boolean {
        return this._isTemplateFixed;
    }

    //編集面の向き(0:回転しない,1:90度回転,2:180度回転,3:270度回転)
    private _designDirection: number = 0;
    set designDirection(direction: number) {
        this._designDirection = direction;
    }
    get designDirection(): number {
        return this._designDirection;
    }

    // //↑↑↑↑↑↑↑↑↑↑テンプレートリスト↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓テンプレートカラー リスト↓↓↓↓↓↓↓↓↓↓
    private _selectedTemplateColor: TemplateColor = new TemplateColor();
    set selectedTemplateColor(templateColor: TemplateColor) {
        this._selectedTemplateColor = templateColor;
    }
    get selectedTemplateColor(): TemplateColor {
        return this._selectedTemplateColor;
    }

    private _templateColorList: TemplateColor[] = [new TemplateColor()];
    set templateColorList(templateColorList: TemplateColor[]) {
        this._templateColorList = templateColorList;
    }
    get templateColorList() {
        return this._templateColorList;
    }
    //↑↑↑↑↑↑↑↑↑↑テンプレートカラー リスト↑↑↑↑↑↑↑↑↑↑

    // 「最近使った項目」用の画像カテゴリ
    private get recentItemsNode(): ImageCategory {
        const node = new ImageCategory();
        node.id = -1;
        node.name = TEMPLATE_CATEGORY_RECENT_ITEM_NAME;
        node.isLeaf = true;
        node.isVisible = true;
        node.isSelectable = true;
        return node;
    }

    //↓↓↓↓↓↓↓↓↓↓画像素材カテゴリー↓↓↓↓↓↓↓↓↓↓
    private _imageCategoryList: ImageCategory[] = [new ImageCategory()];
    set imageCategoryList(imageCategoryList: ImageCategory[]) {
        // IE以外では「最近使った項目」を持たせる
        if (UserAgentHelper.getBrowser() === "ie") {
            this._imageCategoryList = imageCategoryList;
        } else {
            this._imageCategoryList = [
                this.recentItemsNode,
                ...imageCategoryList
            ];
        }
    }
    get imageCategoryList() {
        return this._imageCategoryList;
    }
    private _selectedImageCategory: ImageCategory = new ImageCategory();
    set selectedImageCategory(imageCategory: ImageCategory) {
        this._selectedImageCategory = imageCategory;
    }
    get selectedImageCategory(): ImageCategory {
        return this._selectedImageCategory;
    }
    //↑↑↑↑↑↑↑↑↑↑画像素材カテゴリー↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓画像素材リスト↓↓↓↓↓↓↓↓↓↓
    private _imageList: Image[] = [new Image()];
    set imageList(imageList: Image[]) {
        this._imageList = imageList;
    }
    get imageList() {
        return this._imageList;
    }
    //↑↑↑↑↑↑↑↑↑↑画像素材リスト↑↑↑↑↑↑↑↑↑↑

    //** Google fonts **//
    private _googleFontList: any = null;
    public get googleFontList() {
        return this._googleFontList;
    }
    public set googleFontList(googleFontList) {
        this._googleFontList = googleFontList;
    }

    constructor() {
        // mobileではこの処理をしない
        if (UserAgentHelper.isMobile()) {
            this.isLoadAllVisibleProduct = false;
            return;
        }
        localStorage.setItem("ipc-api-state", "loading");
        ipcApi().then(() => {
            localStorage.setItem("ipc-api-state", "loaded");
            this.createNewProductCategory().then(() => {
                this.initTemplateCategory();
            });
            this.createImageCategory("create");
        });
    }

    // 通信失敗時の初期値を設定する
    private initTemplateCategoryDefault() {
        const tc = new TemplateCategory(TEMPLATE_CATEGORY_RECENT_ITEM_NAME);
        const t = new Template();
        tc.isLeaf = true;
        tc.count = 1;
        tc.firstNode = true;
        tc.isVisible = true;
        tc.isSelectable = true;
        tc.hierarchy = 1;
        this.templateCategoryList = [tc];
        this.templateList = [t];
        this.templateTotalCount = 1;
        this.selectedTemplateCategory = tc;
        this.selectedTemplate = t;
    }

    private currentProductPage: number = 1;
    private productRepository?: IProductRepository;

    private initProductCategory(
        categories: ProductCategory[],
        productsCount: number
    ) {
        this.productCategoryList = categories;
        this.productTotalCount = productsCount;
        if (categories.length > 0 && categories[0].productList.length > 0) {
            const firstProduct = categories[0].productList[0];
            this.selectProduct(firstProduct.id, firstProduct.productCategoryId);
        }
    }

    // とりあえず切り出しただけ
    // FIXME Productが初期化されていないと実行できない
    private initTemplateCategory() {
        //☆テンプレートカテゴリーリスト作成
        this.createTemplateCategory(
            "create",
            () => {
                //テンプレートカラーリスト作成
                this.createTemplateColorList(
                    () => {
                        DebugHelper.trace("loading completed");
                        //ローディングアニメーション非表示
                        this.isLoadAllVisibleProduct = false;
                    },
                    () => {
                        DebugHelper.trace("communication error");
                        //ローディングアニメーション非表示
                        this.isLoadAllVisibleProduct = false;
                    }
                );
            },
            () => {
                DebugHelper.trace("communication error");
                this.initTemplateCategoryDefault(); // 初期値を入れる
                //ローディングアニメーション非表示
                this.isLoadAllVisibleProduct = false;
            }
        );
    }

    /**
     * 商品一覧を作る
     */
    createNewProductCategory(): Promise<never> {
        return new Promise(resolve => {
            this.currentProductPage = 1;
            this.isLoadAllVisibleProduct = true;

            const xhr = XHRProductRepository.all();
            const idb = IDBProductRepository.all();
            this.initProduct(xhr, idb).then(() => {
                this.isLoadNewVisibleProduct = true;
                resolve();
            });
        });
    }

    // ざっくり切り出した
    private initProduct(
        xhr: IProductRepository,
        idb: Promise<IProductRepository>
    ) {
        return new Promise(resolve => {
            this.productRepository = xhr;
            this.productRepository
                .paginate(1)
                .then(([categories, productsCount]) => {
                    this.initProductCategory(categories, productsCount);
                    resolve();
                })
                .catch(() => {
                    // 通信が失敗したらidbに切り替える
                    idb.then(repository => {
                        this.productRepository = repository;
                        this.productRepository
                            .paginate(1)
                            .then(([categories, productsCount]) => {
                                this.initProductCategory(
                                    categories,
                                    productsCount
                                );
                                resolve();
                            });
                    });
                });
        });
    }

    private finishFirstLoadingProduct() {
        this.isLoadAllVisibleProduct = false;
        this.isLoadNewVisibleProduct = true;
    }

    // FIXME 整理して重複を減らす
    /**
     * 商品を検索する
     * @param type 検索タイプ
     * @param info 検索条件
     */
    searchProductCategory(type: string, info: productSearchInfo) {
        return new Promise(() => {
            this.currentProductPage = 1;
            this.isLoadAllVisibleProduct = true;

            if (type === "text") {
                const xhr = XHRProductRepository.searchWithWord(
                    info.searchWord
                );
                const idb = IDBProductRepository.searchWithWord(
                    info.searchWord
                );
                this.initProduct(xhr, idb).then(() =>
                    this.finishFirstLoadingProduct()
                );
            } else if (type === "size") {
                const xhr = XHRProductRepository.searchWithSize(
                    info.width,
                    info.height,
                    info.range
                );
                const idb = IDBProductRepository.searchWithSize(
                    info.width,
                    info.height,
                    info.range
                );
                this.initProduct(xhr, idb).then(() =>
                    this.finishFirstLoadingProduct()
                );
            } else {
                const xhr = XHRProductRepository.all();
                const idb = IDBProductRepository.all();
                this.initProduct(xhr, idb).then(() =>
                    this.finishFirstLoadingProduct()
                );
            }
        });
    }

    /**
     * 次の商品ページを読み込む
     */
    appendProductCategory() {
        if (!this.productRepository) return;
        this.productRepository
            .paginate(this.currentProductPage + 1)
            .then(([categories, productsCount]) => {
                if (categories.length === 0) {
                    // これ以上読み込めない
                    this.isLoadNewVisibleProduct = false;
                    return;
                }
                categories.forEach(category => {
                    if (
                        category.id ===
                        this.productCategoryList[
                            this.productCategoryList.length - 1
                        ].id
                    ) {
                        this.productCategoryList[
                            this.productCategoryList.length - 1
                        ].productList = this.productCategoryList[
                            this.productCategoryList.length - 1
                        ].productList.concat(category.productList);
                    } else {
                        this.productCategoryList.push(category);
                    }
                });
                this.currentProductPage += 1;
            })
            .catch(() => {
                // 失敗したら諦める
                // TODO 何度か試行した方がいいのか？
                this.isLoadNewVisibleProduct = false;
            });
    }

    /**
     * 商品一覧を作る
     * @param type 実行する処理のタイプ
     */
    createProductCategory(type: string) {
        if (type == "create") {
            this.createNewProductCategory();
        } else if (type == "search") {
            const type = (this.productSearchTypeConfirmed = this.productSearchType);
            const info = this.productSearchInfo;
            this.searchProductCategory(type, info);
        } else if (type == "loadNew") {
            this.appendProductCategory();
        }
    }

    //商品選択
    // FIXME Productがない場合は困る
    selectProduct(
        productId: number,
        productCategoryId: number,
        sendLog = false
    ) {
        for (var i = 0; i < this.productCategoryList.length; i++) {
            for (
                var j = 0;
                j < this.productCategoryList[i].productList.length;
                j++
            ) {
                if (
                    this.productCategoryList[i].productList[j].id ==
                        productId &&
                    this.productCategoryList[i].productList[j]
                        .productCategoryId == productCategoryId
                ) {
                    //選択商品の更新
                    this.selectedProduct = this.productCategoryList[
                        i
                    ].productList[j];

                    //選択用紙の更新
                    this.selectPaper(this.selectedProduct.paperList[0].id);

                    //選択中のテンプレートカテゴリーと、表示するテンプレートのリストを更新
                    // this.selectTemplateCategory(this.selectedProduct.productCategoryId, 0)

                    if (sendLog) {
                        // var logValue = "{ \"codeWeb\" : \"" + this.selectedProduct.codeWeb
                        // +  "\" , \"code\" : \"" + this.selectedProduct.paperList[0].code + "\" }";
                        // LogHelper.sendLog("200" , logValue);
                    }
                }
            }
        }
    }

    //用紙を選択
    selectPaper(paperId: number) {
        this.selectedPaper = Enumerable.asEnumerable(
            this.selectedProduct.paperList
        )
            .Where(x => x.id == paperId)
            .ToArray()[0];
        if (this.selectedPaper.defaultTemplateCategoryId != 0) {
            this.selectTemplateCategory(
                this.selectedPaper.defaultTemplateCategoryId,
                this.selectedPaper.defaultTemplateHierarchy
            );
        } else {
            this.selectTemplateCategory(
                this.selectedProduct.productCategoryId,
                0
            );
        }
    }

    //用紙向き変更
    changePaperDirection(direction: number) {
        this.paperDirection = direction;
        this.createTemplateList("create");
    }

    //↑↑↑↑↑↑↑↑↑↑プロダクト、ペイパー↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓テンプレートカテゴリー↓↓↓↓↓↓↓↓↓↓
    private createTemplateCategory(
        type: string,
        completion: (() => void) | null = null,
        error: (() => void) | null = null
    ) {
        if (type == "create") {
            let request = {
                selectedProductCategoryId: this.selectedProduct
                    .productCategoryId,
                platform: platform.id,
                region: RegionHelper.getRegion()
            };
            const XHR = new XMLHttpRequest();
            const query =
                RequestHelper.getApiUrl("get_template_category_list") +
                CreateGetParamHelper.createGetParam(request);
            XHR.open("GET", query, true);
            XHR.onreadystatechange = () => {
                if (XHR.readyState == XMLHttpRequest.DONE) {
                    if (XHR.status === 200) {
                        let responseTemplateCategoryList: TemplateCategory[] = JSON.parse(
                            XHR.response
                        ).data.templateCategoryList;
                        //格納
                        // 常に「最近使った項目」を入れる
                        this.templateCategoryList = [
                            new TemplateCategory(TEMPLATE_CATEGORY_RECENT_ITEM_NAME),
                            ...responseTemplateCategoryList
                        ];

                        //isSelectedがすでに0番目に付与されている
                        this.selectedTemplateCategory = Enumerable.asEnumerable(
                            this.templateCategoryList
                        )
                            .Where(x => x.isSelected)
                            .ToArray()[0];

                        //☆テンプレートリスト作成
                        this.createTemplateList("create");

                        if (completion != null) {
                            completion();
                        }
                    } else {
                        if (error != null) {
                            error();
                        }
                    }
                }
            };
            XHR.send(null);
        }
    }

    //テンプレートカテゴリーを選択する
    selectTemplateCategory(categoryId: number, categoryHierarchy: number) {
        this.isLoadNewVisibleTemplate = true;

        //選択中を消す
        this.eraseSelectedTemplateCategory();
        //選択中のテンプレートカテゴリーの更新
        this.updateSelectedTemplateCategory(categoryId, categoryHierarchy);
        //テンプレートリスト作成
        this.createTemplateList("create");
    }

    // テンプレートカテゴリの開閉
    openOrCloseTemplateCategory(
        categoryId: number,
        categoryHierarchy: number,
        templateCategoryList = this.templateCategoryList
    ) {
        for (var i = 0; i < templateCategoryList.length; i++) {
            if (
                templateCategoryList[i].id == categoryId &&
                templateCategoryList[i].hierarchy == categoryHierarchy
            ) {
                templateCategoryList[i].isExpanded = !templateCategoryList[i]
                    .isExpanded;
                return;
            }
            if (
                templateCategoryList[i].children &&
                templateCategoryList[i].children.length > 0
            ) {
                this.openOrCloseTemplateCategory(
                    categoryId,
                    categoryHierarchy,
                    templateCategoryList[i].children
                );
            }
        }
    }

    // テンプレートカテゴリを開く
    openTemplateCategory(
        categoryId: number,
        categoryHierarchy: number,
        templateCategoryList = this.templateCategoryList
    ) {
        for (var i = 0; i < templateCategoryList.length; i++) {
            if (
                templateCategoryList[i].id == categoryId &&
                templateCategoryList[i].hierarchy == categoryHierarchy
            ) {
                templateCategoryList[i].isExpanded = true;
                return;
            }
            if (
                templateCategoryList[i].children &&
                templateCategoryList[i].children.length > 0
            ) {
                this.openTemplateCategory(
                    categoryId,
                    categoryHierarchy,
                    templateCategoryList[i].children
                );
            }
        }
    }

    //テンプレートカテゴリーの選択状態を消す
    eraseSelectedTemplateCategory(
        templateCategoryList: TemplateCategory[] = this.templateCategoryList
    ) {
        for (var i = 0; i < templateCategoryList.length; i++) {
            if (templateCategoryList[i].isSelected) {
                templateCategoryList[i].isSelected = false;
                return;
            }
            if (
                templateCategoryList[i].children &&
                templateCategoryList[i].children.length > 0
            ) {
                this.eraseSelectedTemplateCategory(
                    templateCategoryList[i].children
                );
            }
        }
    }

    //テンプレートカテゴリーを選択する
    private updateSelectedTemplateCategory(
        categoryId: number,
        categoryHierarchy: number,
        templateCategoryList: TemplateCategory[] = this.templateCategoryList
    ) {
        for (var i = 0; i < templateCategoryList.length; i++) {
            if (
                templateCategoryList[i].id == categoryId &&
                templateCategoryList[i].hierarchy == categoryHierarchy
            ) {
                //ツリーの更新
                templateCategoryList[i].isSelected = true;
                //選択中のカテゴリーを格納
                this.selectedTemplateCategory = templateCategoryList[i];
                return;
            }
            if (
                templateCategoryList[i].children &&
                templateCategoryList[i].children.length > 0
            ) {
                this.updateSelectedTemplateCategory(
                    categoryId,
                    categoryHierarchy,
                    templateCategoryList[i].children
                );
            }
        }
    }

    //テンプレートカテゴリーの検索候補の作成
    createSearchSelection(
        value: string,
        templateCategoryList = this.templateCategoryList
    ) {
        for (var i = 0; i < templateCategoryList.length; i++) {
            if (templateCategoryList[i].name.indexOf(value) === 0) {
                let searchSelectionItem = {
                    id: { id: 0, hierarchy: 0, name: "" },
                    label: "",
                    isSelected: false
                };

                searchSelectionItem.id.id = templateCategoryList[i].id;
                searchSelectionItem.id.hierarchy =
                    templateCategoryList[i].hierarchy;
                searchSelectionItem.id.name = templateCategoryList[i].name;
                searchSelectionItem.label = templateCategoryList[i].path;
                searchSelectionItem.isSelected =
                    this.selectedTemplateCategory.id ==
                    templateCategoryList[i].id;

                this.searchSelection.push(searchSelectionItem);
            }
            if (
                templateCategoryList[i].children &&
                templateCategoryList[i].children.length > 0
            ) {
                this.createSearchSelection(
                    value,
                    templateCategoryList[i].children
                );
            }
        }
    }

    //↑↑↑↑↑↑↑↑↑↑テンプレートカテゴリー↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓テンプレートカラーリスト↓↓↓↓↓↓↓↓↓↓

    createTemplateColorList(
        completion: (() => void) | null = null,
        error: (() => void) | null = null
    ) {
        RequestHelper.get(
            "get_template_color_list",
            { platform: String(platform.id), region: RegionHelper.getRegion() },
            response => {
                this.templateColorList = JSON.parse(response).data.colorList;
                if (completion != null) {
                    completion();
                }
            },
            () => {
                if (error != null) {
                    error();
                }
            }
        );
    }

    selectTemplateColor(color: TemplateColor) {
        this.selectedTemplateColor = color;
        this.createTemplateList("create");
    }

    //↑↑↑↑↑↑↑↑↑↑テンプレートカラーリスト↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓テンプレートリスト↓↓↓↓↓↓↓↓↓↓

    /**
      * 最近使ったテンプレートのリストを作る
      */
     private createTemplateListRecent() {
        this.templateList = [];
        this.templateTotalCount = 0;
        this.isLoadNewVisibleTemplate = false;
        this.isLoadAllVisibleTemplate = false;
        getRecentTemplates().then(templates => {
            // SNSテンプレートを表示しない
            templates = Enumerable.asEnumerable(templates).Where(a => !a.isSns).ToArray();
            this.templateList = [
                new Template(),
                ...templates
            ];
            this.templateTotalCount = templates.length + 1;
        })
    }

    /**
     * 「最近使った項目」が選択されているかどうか
     */
    private recentUsedTemplateCategoryIsSelected() {
        // 0は最近使った項目として処理する
        return this.selectedTemplateCategory.id === 0 && this.selectedTemplateCategory.name === TEMPLATE_CATEGORY_RECENT_ITEM_NAME;
    }

    createTemplateList(type: string) {
        if (type == "create") {
            if (this.recentUsedTemplateCategoryIsSelected()) {
                this.createTemplateListRecent();
                return;
            }

            this.isLoadAllVisibleTemplate = true;

            //----------リクエスト作成----------/
            let frameWidthList: number[] = [];
            for (var i = 0; i < this.selectedPaper.frameInfoList.length; i++) {
                frameWidthList[i] = this.selectedPaper.frameInfoList[i].width;
            }

            let frameHeightList: number[] = [];
            for (var i = 0; i < this.selectedPaper.frameInfoList.length; i++) {
                frameHeightList[i] = this.selectedPaper.frameInfoList[i].height;
            }

            let templateSearchInfo: templateSearchInfo;

            if (this.paperDirection == 0 || this.paperDirection == 2) {
                templateSearchInfo = {
                    selectedTemplateCategoryId: this.selectedTemplateCategory
                        .id,
                    selectedTemplateHierarchy: this.selectedTemplateCategory
                        .hierarchy,
                    scrollOld: false,
                    scrollNew: false,
                    page: 0,
                    frameWidthList: frameWidthList.toString(),
                    frameHeightList: frameHeightList.toString(),
                    displayResembles: this.displayResembles,
                    colorId: this.selectedTemplateColor.id,
                    platform: platform.id,
                    region: RegionHelper.getRegion()
                };
            } else {
                templateSearchInfo = {
                    selectedTemplateCategoryId: this.selectedTemplateCategory
                        .id,
                    selectedTemplateHierarchy: this.selectedTemplateCategory
                        .hierarchy,
                    scrollOld: false,
                    scrollNew: false,
                    page: 0,
                    frameWidthList: frameHeightList.toString(),
                    frameHeightList: frameWidthList.toString(),
                    displayResembles: this.displayResembles,
                    colorId: this.selectedTemplateColor.id,
                    platform: platform.id,
                    region: RegionHelper.getRegion()
                };
            }

            this.getTemplatePage = 0;

            //----------リクエスト作成----------/

            const XHR = new XMLHttpRequest();
            const query =
                RequestHelper.getApiUrl("get_template_new_list") +
                CreateGetParamHelper.jsonToQueryString(templateSearchInfo);
            XHR.open("GET", query, true);
            XHR.onreadystatechange = () => {
                if (XHR.readyState == XMLHttpRequest.DONE) {
                    if (XHR.status === 200) {
                        try {
                            // まずテンプレートリストを一度空に
                            this.templateList = [];

                            var response = JSON.parse(XHR.response);
                            this.templateTotalCount = response.data.totalCount;
                            this.getTemplatePage = response.data.page;

                            let responseTemplateList: Template[] = JSON.parse(
                                XHR.response
                            ).data.templateList;

                            if (
                                responseTemplateList &&
                                responseTemplateList.length > 0
                            ) {
                                this.concatTemplateList(responseTemplateList);
                            }

                            this.isLoadAllVisibleTemplate = false;
                            if (this.templateList.length >= 51) {
                                this.isLoadNewVisibleTemplate = true;
                            } else {
                                this.isLoadNewVisibleTemplate = false;
                            }
                        } catch (e) {
                            DebugHelper.trace(e);
                        }
                    } else {
                        // FIXME
                        // エラーが出たら読み込みを諦める
                        this.isLoadNewVisibleTemplate = false;
                        this.isLoadAllVisibleTemplate = false;
                    }
                }
            };
            XHR.send(null);
        } else if (type == "loadNew") {
            //----------リクエスト作成----------/
            let frameWidthList: number[] = [];
            for (var i = 0; i < this.selectedPaper.frameInfoList.length; i++) {
                frameWidthList[i] = this.selectedPaper.frameInfoList[i].width;
            }

            let frameHeightList: number[] = [];
            for (var i = 0; i < this.selectedPaper.frameInfoList.length; i++) {
                frameHeightList[i] = this.selectedPaper.frameInfoList[i].height;
            }

            let templateSearchInfo: templateSearchInfo;

            if (this.paperDirection == 0 || this.paperDirection == 2) {
                templateSearchInfo = {
                    selectedTemplateCategoryId: this.selectedTemplateCategory
                        .id,
                    selectedTemplateHierarchy: this.selectedTemplateCategory
                        .hierarchy,
                    scrollOld: false,
                    scrollNew: true,
                    page: this.getTemplatePage,
                    frameWidthList: frameWidthList.toString(),
                    frameHeightList: frameHeightList.toString(),
                    displayResembles: this.displayResembles,
                    colorId: this.selectedTemplateColor.id,
                    platform: platform.id,
                    region: RegionHelper.getRegion()
                };
            } else {
                templateSearchInfo = {
                    selectedTemplateCategoryId: this.selectedTemplateCategory
                        .id,
                    selectedTemplateHierarchy: this.selectedTemplateCategory
                        .hierarchy,
                    scrollOld: false,
                    scrollNew: true,
                    page: this.getTemplatePage,
                    frameWidthList: frameHeightList.toString(),
                    frameHeightList: frameWidthList.toString(),
                    displayResembles: this.displayResembles,
                    colorId: this.selectedTemplateColor.id,
                    platform: platform.id,
                    region: RegionHelper.getRegion()
                };
            }

            //----------リクエスト作成----------/

            const XHR = new XMLHttpRequest();
            const query =
                RequestHelper.getApiUrl("get_template_new_list") +
                CreateGetParamHelper.jsonToQueryString(templateSearchInfo);
            XHR.open("GET", query, true);
            XHR.onreadystatechange = () => {
                if (
                    XHR.readyState == XMLHttpRequest.DONE &&
                    XHR.status === 200
                ) {
                    try {
                        var response = JSON.parse(XHR.response);
                        let responseTemplateList: Template[] =
                            response.data.templateList;
                        this.getTemplatePage = response.data.page;

                        //格納
                        if (responseTemplateList.length > 0) {
                            if (
                                this.concatTemplateList(responseTemplateList) ==
                                0
                            ) {
                                this.isLoadNewVisibleTemplate = false;
                            }
                        } else {
                            this.isLoadNewVisibleTemplate = false;
                        }
                    } catch (e) {
                        DebugHelper.trace(e);
                    }
                }
            };
            XHR.send(null);
        }
    }

    selectTemplate(templateId: number, sendLog = false) {
        if (templateId == 0) {
            this.selectedTemplate = new Template();
        } else {
            let selectedTemplate = Enumerable.asEnumerable(this.templateList)
                .Where(x => x.id == templateId).FirstOrDefault();
            this.selectedTemplate = selectedTemplate != null ? selectedTemplate : new Template();

            if (sendLog) {
                // LogHelper.sendLog("300" , this.selectedTemplate.id)
            }

            let getTemplateDetailInfo = {
                templateId: this.selectedTemplate.id
            };
        }
    }

    changeDisplayResembles() {
        this.displayResembles = !this.displayResembles;
        this.createTemplateList("create");
    }

    //↑↑↑↑↑↑↑↑↑↑テンプレートリスト↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓画像素材カテゴリー↓↓↓↓↓↓↓↓↓↓

    createImageCategory(type: string) {
        if (type == "create") {
            let request = {
                platform: platform.id,
                region: RegionHelper.getRegion()
            };

            const XHR = new XMLHttpRequest();
            const query =
                RequestHelper.getApiUrl("get_image_category_list") +
                CreateGetParamHelper.createGetParam(request);
            XHR.open("GET", query, true);
            XHR.onreadystatechange = () => {
                if (
                    XHR.readyState == XMLHttpRequest.DONE &&
                    XHR.status === 200
                ) {
                    let responseImageCategoryList: ImageCategory[] = JSON.parse(
                        XHR.response
                    ).data.imageCategory;

                    //格納
                    this.imageCategoryList = responseImageCategoryList;

                    //isSelectedがすでに0番目に付与されている
                    this.selectedImageCategory = Enumerable.asEnumerable(
                        this.imageCategoryList
                    )
                        .Where(x => x.isSelected)
                        .ToArray()[0];

                    //imageリスト作成
                    this.createImageList("create");
                }
            };
            XHR.onerror = e => {
                // 「最近使った項目」は自動で入る
                this.imageCategoryList = [];
                this.selectedImageCategory = this.imageCategoryList[0];
                this.createImageList("create");
            };
            XHR.send(null);
        }
    }

    //イメージカテゴリーを選択する
    selectImageCategory(categoryId: number) {
        //選択中を消す
        this.eraseSelectedImageCategory();
        //選択中のテンプレートカテゴリーの更新
        this.updateSelectedImageCategory(categoryId);
        //テンプレートリスト作成
        this.createImageList("create");
    }

    openImageCategory(
        categoryId: number,
        imageCategoryList = this.imageCategoryList
    ) {
        for (var i = 0; i < imageCategoryList.length; i++) {
            if (imageCategoryList[i].id == categoryId) {
                imageCategoryList[i].isExpanded = !imageCategoryList[i]
                    .isExpanded;
                return;
            }
            if (
                imageCategoryList[i].children &&
                imageCategoryList[i].children.length > 0
            ) {
                this.openImageCategory(
                    categoryId,
                    imageCategoryList[i].children
                );
            }
        }
    }

    //イメージカテゴリーの選択状態を消す
    eraseSelectedImageCategory(
        imageCategoryList: ImageCategory[] = this.imageCategoryList
    ) {
        for (var i = 0; i < imageCategoryList.length; i++) {
            if (imageCategoryList[i].isSelected) {
                imageCategoryList[i].isSelected = false;
                return;
            }
            if (
                imageCategoryList[i].children &&
                imageCategoryList[i].children.length > 0
            ) {
                this.eraseSelectedImageCategory(imageCategoryList[i].children);
            }
        }
    }

    //イメージカテゴリーを選択する
    private updateSelectedImageCategory(
        categoryId: number,
        imageCategoryList: ImageCategory[] = this.imageCategoryList
    ) {
        for (var i = 0; i < imageCategoryList.length; i++) {
            if (imageCategoryList[i].id == categoryId) {
                //ツリーの更新
                imageCategoryList[i].isSelected = true;
                //選択中のカテゴリーを格納
                this.selectedImageCategory = imageCategoryList[i];
                return;
            }
            if (
                imageCategoryList[i].children &&
                imageCategoryList[i].children.length > 0
            ) {
                this.updateSelectedImageCategory(
                    categoryId,
                    imageCategoryList[i].children
                );
            }
        }
    }

    //これをしないと、検索側は参照の変化を認知できないからする必要がある
    // saveImageCategoryTree(updatedImageCategoryList : ImageCategory[]){
    //     this.imageCategoryList = updatedImageCategoryList;
    // }

    //↑↑↑↑↑↑↑↑↑↑画像素材カテゴリー↑↑↑↑↑↑↑↑↑↑

    //↓↓↓↓↓↓↓↓↓↓画像リスト↓↓↓↓↓↓↓↓↓↓

    createImageList(type: string) {
        if (type == "create") {
            if (this.selectedImageCategory.id === -1) {
                // 「最近使った項目」を用意する
                getRecentImages().then(images => {
                    this.imageList = images;
                });
                return;
            }

            //----------リクエスト作成----------/
            let imageSearchInfo = {
                selectedImageCategoryId: this.selectedImageCategory.id,
                platform: platform.id,
                region: RegionHelper.getRegion()
            };
            //----------リクエスト作成----------/

            const XHR = new XMLHttpRequest();
            const query =
                RequestHelper.getApiUrl("get_image_list") +
                CreateGetParamHelper.createGetParam(imageSearchInfo);
            XHR.open("GET", query, true);
            XHR.onreadystatechange = () => {
                if (
                    XHR.readyState == XMLHttpRequest.DONE &&
                    XHR.status === 200
                ) {
                    let responseImageList: Image[] = JSON.parse(XHR.response)
                        .data.imageList;

                    this.imageList = responseImageList;
                }
            };
            XHR.send(null);
        }
    }

    // selectedImageBase64 = ""

    //↑↑↑↑↑↑↑↑↑↑画像リスト↑↑↑↑↑↑↑↑↑↑
}
